<template>
  <div class="h-screen flex overflow-hidden bg-gray-100">
    <!-- Off-canvas menu for mobile -->
    <div class="lg:hidden" v-show="sidebarOnMobileShow">
      <div class="fixed inset-0 flex z-40">

        <transition
          enter-active-class="transition-opacity ease-out duration-300"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition ease-in duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div class="fixed inset-0">
            <div class="absolute inset-0 bg-gray-600 opacity-75" @click.stop="sidebarOnMobileShow = false"></div>
          </div>
        </transition>

        <transition
          enter-active-class="transition ease-in-out duration-300 transform"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="transition ease-in duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gray-900">
            <div class="absolute top-0 right-0 -mr-14 p-1">
              <button class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600" aria-label="Close sidebar" @click="sidebarOnMobileShow = false">
                <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="flex-shrink-0 flex items-center px-4">
              <logo />
            </div>
            <div class="mt-5 flex-1 h-0 overflow-y-auto">
              <main-menu :url="url()" class="flex-shrink-0 w-40 p-4 overflow-y-auto" />
            </div>
          </div>
        </transition>

        <div class="flex-shrink-0 w-14">
          <!-- Dummy element to force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </div>

    <!-- Static sidebar for desktop -->
    <transition
      enter-active-class="transition-all ease-in-out duration-300 transform"
      enter-class="-translate-x-full"
      enter-to-class="translate-x-0"
      leave-class="translate-x-0"
      leave-to-class="-translate-x-full"
    >
      <div class="hidden lg:flex lg:flex-shrink-0" v-show="sidebarOnMobileShow">
        <div class="flex flex-col w-64">
          <div class="flex flex-col flex-grow to-gray-800 bg-gray-900 pt-5 pb-4 overflow-y-auto">
            <div class="flex items-center flex-shrink-0 px-4">
              <logo />
            </div>
            <div class="mt-5 flex-1 flex flex-col">
              <main-menu :url="url()" class="flex-shrink-0 w-40 p-4 hidden lg:block overflow-y-auto" />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <div class="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
        <button class="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:bg-gray-100 focus:text-gray-600" aria-label="Open sidebar" @click="sidebarOnMobileShow = !sidebarOnMobileShow">
          <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24" v-if="!sidebarOnMobileShow">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" />
          </svg>
          <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24" v-else>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path>
          </svg>

        </button>
        <div class="flex-1 px-4 flex justify-between">
          <div class="flex-1 flex">
            <portal-target name="search"></portal-target>
          </div>
          <div class="ml-4 flex items-center md:ml-6">
            <div>
              <portal-target name="quickActions"></portal-target>
            </div>

            <!-- Profile dropdown -->
            <dropdown class="mt-1 z-20" placement="bottom-end">
              <div class="flex items-center cursor-pointer select-none group">
<!--                <div class="text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 mr-1 whitespace-nowrap">-->
<!--                  <span>{{ $page.props.auth.user.first_name }}</span>-->
<!--                  <span class="hidden md:inline">{{ $page.props.auth.user.last_name }}</span>-->
<!--                </div>-->
                <button class="p-1 text-gray-500 rounded-full hover:bg-green-100 hover:text-gray-800 focus:outline-none focus:shadow-outline focus:text-gray-900">
                  <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                </button>
                <icon class="w-5 h-5 group-hover:fill-indigo-600 fill-gray-700 focus:fill-indigo-600" name="cheveron-down" />
              </div>
              <div slot="dropdown" class="">

                <inertia-link class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" :href="route('customer.logout')" as="button" method="post">Logout</inertia-link>
              </div>
            </dropdown>
          </div>
        </div>
      </div>

      <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
        <div class="pt-2 pb-6 lg:py-6">
          <div class="xl:container mx-auto px-4 sm:px-6 lg:px-8">
            <flash-messages />
            <slot></slot>
          </div>
        </div>
      </main>
    </div>
    <annoucements-notification></annoucements-notification>
    <tawkto v-if="$page.props.enable_tawk" class="mb-6 pb-5"></tawkto>
  </div>
</template>
<script>
  import Dropdown from '@/Shared/Dropdown'
  import FlashMessages from '@/Shared/FlashMessages'
  import Icon from '@/Shared/Icon'
  import Logo from '@/Shared/Logo'
  import MainMenu from './MainMenu'
  import AnnoucementsNotification from '../AnnoucementsNotification'
  import Tawkto from '@/Shared/Tawkto'

  export default {
    name: 'SidebarLayout',
    components: { Logo, MainMenu, Icon, Dropdown, FlashMessages, AnnoucementsNotification, Tawkto },

    data() {
      return {
        showUserMenu: false,
        sidebarOnMobileShow: false
      }
    },

    methods: {
      url() {
        return location.pathname.substr(1)
      },
      hideDropdownMenus() {
        this.showUserMenu = false
      },
    },
  }
</script>
